import React from 'react';
import { PageLayout } from 'components/PageLayout';
import { ReciboForm } from 'components/DocumentForm/recibo';

export const NewRecibo = () => {
  return (
    <PageLayout title="Nuevo Recibo" padding={false} whiteBg={false}>
      <ReciboForm />
    </PageLayout>
  );
};
